import React from 'react';

const Loader = () => {
    return (
        <div style={styles.loader}>
            Loading...
        </div>
    );
};

const styles = {
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '1.5rem',
        fontWeight: 'bold',
    },
};

export default Loader;